import React, { useState } from 'react';
import Form from '../common/Form';
import FormField from '../common/FormField';
import { SubRegionDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';
import { useFormValidation, ValidationRules } from '../../hooks/useFormValidation';

interface SubRegionFormProps {
  initialValues: SubRegionDTO;
  countryId: string;
  stateOptions: { value: string; label: string }[];
  onSubmit: (data: SubRegionDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const validationRules: ValidationRules = {
  name: [{ required: true, message: 'Name is required' }],
};

const SubRegionForm: React.FC<SubRegionFormProps> = ({
  initialValues,
  countryId,
  stateOptions,
  onSubmit,
  onCancel,
  isLoading = false,
}) => {
  const [formData, setFormData] = useState<SubRegionDTO>({
    ...initialValues,
    countryId,
  });

  const { errors, validate } = useFormValidation<SubRegionDTO>(validationRules);

  const handleSave = () => {
    if (validate(formData)) {
      onSubmit({ ...formData, countryId });
    }
  };

  return (
    <Form sections={[]} onSave={handleSave} onCancel={onCancel} isSubmitting={isLoading} hideHeader>
      <FormField
        id="name"
        label="Name"
        type="text"
        value={formData.name || ''}
        onChange={(e) => handleChange(e, setFormData)}
        placeholder="Enter Name"
        required
        error={errors.name}
      />
      <FormField
        id="code"
        label="Code"
        type="text"
        value={formData.code || ''}
        onChange={(e) => handleChange(e, setFormData)}
        placeholder="Enter Code"
        error={errors.code}
      />
      <FormField
        id="stateId"
        label="State"
        type="dropdown"
        value={formData.stateId || ''}
        onChange={(e) => handleChange(e, setFormData)}
        options={[{ value: '', label: '(None)' }, ...stateOptions]}
        placeholder="Select a State (optional)"
      />
    </Form>
  );
};

export default SubRegionForm;
